import * as React from 'react';
import bind from '@reverbdotcom/commons/dist/bind';
import { get, first } from 'lodash';
import gql from 'graphql-tag';
import { ChildProps, compose, MutationFn, graphql } from 'react-apollo';
import {
  Input_core_apimessages_ReverifyCreditCardRequest,
  ReverifyCreditCardMutation,
} from '../schemas/rql';
import TokenizedCvvField from './tokenized_cvv_field';

export interface ITokenizedCvv {
  encryptedSecurityCode: string;
}

interface IExternalProps {
  creditCardId: string;
}

interface ApolloProps {
  reverifyCreditCard: MutationFn<any, any>;
}

type IProps = ChildProps<IExternalProps> & ApolloProps;

interface IState {
  isFormSaving: boolean;
  error: string;
  tokenizedFields: ITokenizedCvv;
}

export const connectReverifyCardMutation = graphql<{}, ReverifyCreditCardMutation.Mutation, ReverifyCreditCardMutation.Variables>(
  gql`mutation reverifyCreditCardMutation($input: Input_core_apimessages_ReverifyCreditCardRequest) {
    reverifyCreditCard(input: $input) {
      creditCard {
        id
        last4
        cardType
        expirationYear
        expirationMonth
        cardholderName
        needsReverification
        primaryForCheckout
      }
    }
  }`,
  {
    name: 'reverifyCreditCard',
    options: {
      ssr: false,
    },
  });

export class ReverifyCardContainer extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      isFormSaving: false,
      error: '',
      tokenizedFields: {
        encryptedSecurityCode: '',
      },
    };
  }

  @bind
  onTokenizedFieldUpdate(newTokenizedFields: ITokenizedCvv) {
    const tokenizedFields: ITokenizedCvv = { ...this.state.tokenizedFields, ...newTokenizedFields };
    this.setState({ tokenizedFields });
  }

  disableSubmit() {
    return (
      this.state.isFormSaving ||
        !this.state.tokenizedFields.encryptedSecurityCode
    );
  }

  @bind
  async handleSubmit(e) {
    e.preventDefault();

    this.setState({ isFormSaving: true, error: '' });

    try {
      await this.doReverifyCard();

      this.setState({ isFormSaving: false });
    } catch (errors) {
      const { message } = first(get(errors, 'graphQLErrors', [{ message: '' }]));
      this.setState({ error: message, isFormSaving: false });
    }
  }

  @bind
  async doReverifyCard(): Promise<any> {
    const tokenizedFieldsJson = JSON.stringify(this.state.tokenizedFields);

    const input: Input_core_apimessages_ReverifyCreditCardRequest = {
      creditCardId: this.props.creditCardId,
      tokenizedFields: tokenizedFieldsJson,
    };

    const result = await this.props.reverifyCreditCard({ variables: { input } });
    return get(result, 'data.creditCard');
  }

  errorReverifying() {
    return this.state.error !== '';
  }

  render() {
    return (
      <TokenizedCvvField
        creditCardId={this.props.creditCardId}
        onTokenizedFieldUpdate={this.onTokenizedFieldUpdate}
        errorReverifying={this.errorReverifying()}
        disableSubmit={this.disableSubmit()}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const connectReverifyCardContainer: React.SFC<IExternalProps> = compose(
  connectReverifyCardMutation,
)(ReverifyCardContainer);

export default connectReverifyCardContainer;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/reverify_card_container.tsx